import { Cart } from '@/schema/cart';

type CurrentStock = {
  [serial: string]: {
    useStock: boolean;
    stock: number;
    soldCount: number;
  };
};

interface CheckCartStockParams {
  carts: Cart[];
  fetchStock: (shopId: string) => Promise<CurrentStock>;
  onSoldOut?: (item: { shopId: string; serial: string }) => void;
}

export async function checkCartStock({
  carts,
  fetchStock,
  onSoldOut,
}: CheckCartStockParams): Promise<{
  hasSoldOut: boolean;
  stockMap: Record<string, CurrentStock>;
}> {
  const uniqueShopIds = [...new Set(carts.map(c => c.shopId))];

  const stockMap: Record<string, CurrentStock> = {};

  await Promise.all(
    uniqueShopIds.map(async shopId => {
      stockMap[shopId] = await fetchStock(shopId);
    }),
  );

  let hasSoldOut = false;

  for (const cart of carts) {
    const shopId = cart.shopId;
    const stock = stockMap[shopId];

    for (const item of cart.cart.result) {
      const s = stock[item.serial];
      if (s && s.useStock && s.stock - s.soldCount - item.count < 0) {
        onSoldOut?.({ shopId, serial: item.serial });
        hasSoldOut = true;
      }
    }
  }

  return { hasSoldOut, stockMap };
}
